import i18n from "../i18n";
import assignWorkoutToFolder from "./helpers/assign-workout-folder";

const clearModalAndBack = (res) => {
  res.refreshWith(
    { modal: "", targetFolderId: "", cycleId: "", workoutId: "" },
    { url: "back", hash: "#_" }
  );
};

const WorkoutFolders = (app) => {
  app
    // Create or update a folder (PUT not supported in Rill; pass id in body to update)
    .post("/workout-folders", async ({ req, res, flash, api, locals }) => {
      const { id, ...body } = req.body;
      const coachId = locals.activeUserToRequest._id;
      try {
        if (id) {
          await api(`workout-folders/${id}`, {
            method: "PUT",
            body: { ...body, coachId },
          });
          flash(
            "success",
            i18n.t(
              "coaching-portal:workoutFolderActions.updatedSuccessfully",
              "Folder updated successfully"
            )
          );
        } else {
          await api("workout-folders", {
            method: "POST",
            body: { ...body, coachId },
          });
          flash(
            "success",
            i18n.t(
              "coaching-portal:workoutFolderActions.createdSuccessfully",
              "Folder created successfully"
            )
          );
        }
      } catch (e) {
        flash("error", e.message);
      }
      clearModalAndBack(res);
    })
    // Delete a folder
    .post(
      "/workout-folders/remove",
      async ({ req, res, flash, api, locals }) => {
        const { id } = req.body;
        const coachId = locals.activeUserToRequest._id;
        try {
          await api(`workout-folders/${id}`, {
            method: "DELETE",
            query: { coachId },
          });
          flash(
            "success",
            i18n.t(
              "coaching-portal:workoutFolderActions.deletedSuccessfully",
              "Folder deleted successfully"
            )
          );
        } catch (e) {
          flash("error", e.message);
        }
        // Also clear page folderId in case the deleted folder was open
        res.refreshWith(
          {
            modal: "",
            targetFolderId: "",
            cycleId: "",
            workoutId: "",
            folderId: "",
          },
          { url: "back", hash: "#_" }
        );
      }
    )
    // Duplicate a folder (metadata only, empty workoutIds)
    .post(
      "/workout-folders/duplicate",
      async ({ req, res, flash, api, locals }) => {
        const { folderId } = req.body;
        const coachId = locals.activeUserToRequest._id;
        try {
          await api("workout-folders-duplicate", {
            method: "POST",
            body: { folderId, coachId },
          });
          flash(
            "success",
            i18n.t(
              "coaching-portal:workoutFolderActions.duplicatedSuccessfully",
              "Folder duplicated successfully"
            )
          );
        } catch (e) {
          flash("error", e.message);
        }
        clearModalAndBack(res);
      }
    )
    // Assign / unassign a single workout to a folder
    .post(
      "/workout-folders/assign",
      async ({ req, res, flash, api, locals }) => {
        const { folderId, workoutId } = req.body;
        const coachId = locals.activeUserToRequest._id;

        try {
          await assignWorkoutToFolder({ api, coachId, workoutId, folderId });

          flash(
            "success",
            i18n.t(
              "coaching-portal:workoutFolderActions.assignedSuccessfully",
              "Workout folder updated"
            )
          );
        } catch (e) {
          flash("error", e.message);
        }
        clearModalAndBack(res);
      }
    );
};

export default WorkoutFolders;
